module.exports = __webpack_public_path__ + "img/honor.4eae9494.jpg";